<template>
  <v-row justify="center">
    <v-dialog v-model="$store.state.search_admin" persistent width="824">
      <v-card id="adminFilter" :class="isDark ? 'adminFilter--dark' : 'adminFilter--light'">
        <v-card-title style="display: flex; justify-content: space-between">
          <span>البحث</span>
          <v-icon color="red" @click="$store.state.search_admin = false"
            >mdi-close</v-icon
          >
        </v-card-title>
        <hr />
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div  :class="['filterAllRequestsTabs', isDark ? 'filterAllRequestsTabs--dark' : 'filterAllRequestsTabs--light']">
                  <v-tabs v-model="panel" 
                  :background-color="isDark ? '#1f1f1f' : '#f7f7f7'"  grow>
                    <v-tab>
                      <v-badge
                        :content="tabCounts.requests"
                        :value="tabCounts.requests > 0"
                        color="green"
                        overlap
                        bordered
                        top
                      >
                        <span class="d-flex align-center" style="gap: 8px">
                          <SearchIconWhite v-if="$store.getters.isDark" />
                          <SearchIconBlack v-else />
                          <span :style="{ color: isDark ? '#ffffff' : 'black' }" style="font-weight: bold">تصفيه الطلبات</span>
                        </span>
                      </v-badge>
                    </v-tab>
  
                    <v-tab>
                      <v-badge
                        :content="tabCounts.types"
                        :value="tabCounts.types > 0"
                        color="green"
                        overlap
                        bordered
                        top
                      >
                        <span class="d-flex align-center" style="gap: 8px">
                          <SearchIconWhite v-if="$store.getters.isDark" />
                          <SearchIconBlack v-else />
                          <span :style="{ color: isDark ? '#ffffff' : 'black' }" style="font-weight: bold">التصنيفات</span>
                        </span>
                      </v-badge>
                    </v-tab>

                    <v-tab>
                      <v-badge
                        :content="tabCounts.cs"
                        :value="tabCounts.cs > 0"
                        color="green"
                        overlap
                        bordered
                        top
                      >
                        <span class="d-flex align-center" style="gap: 8px">
                          <SearchIconWhite v-if="$store.getters.isDark" />
                          <SearchIconBlack v-else />
                          <span :style="{ color: isDark ? '#ffffff' : 'black' }" style="font-weight: bold">خدمة العملاء</span>
                        </span>
                      </v-badge>
                    </v-tab>

                    <v-tab>
                      <v-badge
                        :content="tabCounts.client"
                        :value="tabCounts.client > 0"
                        color="green"
                        overlap
                        bordered
                        top
                      >
                        <span class="d-flex align-center" style="gap: 8px">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="18.574"
                            height="16.641"
                            viewBox="0 0 18.574 16.641"
                            :fill="$store.getters.isDark ? '#ffffff' : 'black'"
                          >
                            <g
                              id="Group_3168"
                              data-name="Group 3168"
                              transform="translate(0.5 0.5)"
                              :fill="$store.getters.isDark ? '#ffffff' : 'black'"
                            >
                              <path
                                id="Path_30"
                                data-name="Path 30"
                                d="M14.228,591.566v-2.294a3.022,3.022,0,0,0-3.022-3.022H4.442a3.022,3.022,0,0,0-3.022,3.022v2.294"
                                transform="translate(-1.42 -575.975)"
                                :fill="$store.getters.isDark ? '#ffffff' : 'black'"
                                :stroke="$store.getters.isDark ? '#ffffff' : 'black'"
                                stroke-linecap="round"
                                stroke-miterlimit="10"
                                stroke-width="1"
                              />
                              <circle
                                id="Ellipse_14"
                                data-name="Ellipse 14"
                                cx="3.505"
                                cy="3.505"
                                r="3.505"
                                transform="translate(2.899 0)"
                                :fill="$store.getters.isDark ? '#ffffff' : 'black'"
                                :stroke="$store.getters.isDark ? '#ffffff' : 'black'"
                                stroke-linecap="round"
                                stroke-miterlimit="10"
                                stroke-width="1"
                              />
                              <path
                                id="Path_31"
                                data-name="Path 31"
                                d="M23.58,566.05a3.5,3.5,0,0,1,0,7.01"
                                transform="translate(-12.308 -566.05)"
                                :fill="$store.getters.isDark ? '#ffffff' : 'black'"
                                :stroke="$store.getters.isDark ? '#ffffff' : 'black'"
                                stroke-linecap="round"
                                stroke-miterlimit="10"
                                stroke-width="1"
                              />
                              <path
                                id="Path_32"
                                data-name="Path 32"
                                d="M30.47,585.3s3.23.727,2.747,5.8"
                                transform="translate(-15.693 -575.508)"
                                :fill="$store.getters.isDark ? '#ffffff' : 'black'"
                                :stroke="$store.getters.isDark ? '#ffffff' : 'black'"
                                stroke-linecap="round"
                                stroke-miterlimit="10"
                                stroke-width="1"
                              />
                            </g>
                          </svg>
                          <span :style="{ color: isDark ? '#ffffff' : 'black' }" style="font-weight: bold">العميل</span>
                        </span>
                      </v-badge>
                    </v-tab>
  
                    <v-tab>
                      <v-badge
                        :content="tabCounts.quality"
                        :value="tabCounts.quality > 0"
                        color="green"
                        overlap
                        bordered
                        top
                      >
                        <span class="d-flex align-center" style="gap: 8px">
                          <SearchIconWhite v-if="$store.getters.isDark" />
                          <SearchIconBlack v-else />
                          <span :style="{ color: isDark ? '#ffffff' : 'black' }" style="font-weight: bold">الجودة</span>
                        </span>
                      </v-badge>
                    </v-tab>
  
                    <v-tab>
                      <v-badge
                        :content="tabCounts.fundingAvg"
                        :value="tabCounts.fundingAvg > 0"
                        color="green"
                        overlap
                        bordered
                        top
                      >
                        <span class="d-flex align-center" style="gap: 8px">
                          <SearchIconWhite v-if="$store.getters.isDark" />
                          <SearchIconBlack v-else />
                          <span :style="{ color: isDark ? '#ffffff' : 'black' }" style="font-weight: bold">متوسط التمويل</span>
                        </span>
                      </v-badge>
                    </v-tab>
                  </v-tabs>
  
                  <v-tabs-items v-model="panel"  :dark="isDark" class="DailyReportAdmin">
                    <v-tab-item>
                      <div class="panalContextFilter">
                        <v-form>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-radio-group v-model="filterType">
                                <div style="display: flex">
                                  <v-radio label="الملاحظة" value="الملاحظة"></v-radio>
                                  <v-radio
                                    label="إسم العميل"
                                    value="إسم العميل"
                                    style="margin-right: 30px"
                                  ></v-radio>
                                </div>
                              </v-radio-group>
                            </v-col>
  
                            <v-col cols="12" sm="8" md="8" style="margin-top: -15px">
                              <v-text-field
                                :label="' جزء من ' + filterType"
                                v-model="filterTypeParts"
                                outlined
                                dense
                              >
                              </v-text-field>
                            </v-col>
  
                            <v-col cols="12" sm="4" md="4">
                              <v-autocomplete
                                :items="['نعم', 'لا','لا يوجد']"
                                label=" هل بالامكان البيع للعميل؟"
                                v-model="PossibleToSellToCustomer"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <template slot="item.req_product_type" slot-scope="props">
                              <span v-if="props.item.req_product_type !== 'لا_يوجد'" style="font-family: Dintext">{{ props.item.req_product_type }}</span>
                              <span v-else style="color: red;font-family: Dintext">{{ props.item.req_product_type }}</span>
                            </template>
                            <template slot="item.customer_name" slot-scope="props">
                              <span v-if="!props.item.customer_name"></span>
                              <v-tooltip bottom v-else>
                                <template v-slot:activator="{ on }">
                  <span v-on="on">{{
                      props.item.customer_name.length > 7
                          ? props.item.customer_name.substring(0, 7) + "..."
                          : props.item.customer_name
                    }}</span>
                                </template>
                                <div class="font-weight-bold">{{ props.item.customer_mobile }}</div>
                              </v-tooltip>
                            </template>
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput1"
                                @selectedValues="getSelectedValueManger"
                                :originalItems="getManagerNames"
                                label="مدير المبيعات"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput24"
                                @selectedValues="getFundingManagers"
                                :originalItems="getFundingManagersName"
                                label="مدير التمويل"
                              />
                            </v-col>
                           
  
                            <v-col cols="12" sm="6" md="4" v-if="$route.name == 'administration_requests'" >
                              <SelectInput
                                ref="selectInput2"
                                @selectedValues="getAgentBeforeSendingToAdministration"
                                :originalItems="getAgentsName"
                                label="استشاري المبيعات"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4" v-else>
                              <SelectInput
                                ref="selectInput2"
                                @selectedValues="getSelectedValueAgent"
                                :originalItems="salesAgentsOnly"
                                label="استشاري المبيعات"
                              />
                            </v-col>

                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                @selectedValues="getSelectedCustomerService"
                                :originalItems="customerServiceAgents"
                                label="خدمة العملاء"
                              />
                            </v-col>
                            
                            <v-col cols="12" sm="6" md="4">
                              <v-autocomplete
                                :items="allStatus"
                                label="الحالة"
                                v-model="selectedStatusFilter"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4">
                              <v-autocomplete
                                :items="['الكل','نعم','لا']"
                                label=" الموافقه علي الارشفة ؟"
                                v-model="selectedAcceptArchivedOrNot"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
  
                            <v-col cols="12" sm="4" md="4">
                              <v-autocomplete
                                :items="['لا', 'نعم']"
                                label="طلبات تحتوي علي مكالمات"
                                v-model="isHasCalls"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>


                            <v-col cols="12" sm="4" md="4" v-if="isHasCalls === 'نعم'">
                              <SelectInput
                                @selectedValues="getCallConsultants"
                                :originalItems="callCenterConsultants"
                                label="استشاري المكالمة"
                              />
                            </v-col>

                            <v-col cols="12" sm="4" md="4" v-if="isHasCalls === 'نعم'">
                              <v-text-field
                                label="مدة المكالمة من (بالثواني)"
                                v-model="callsDurationFrom"
                                outlined
                                dense
                                type="number"
                                min="0"
                                inputmode="numeric"
                              />
                            </v-col>
                            <v-col cols="12" sm="4" md="4" v-if="isHasCalls === 'نعم'">
                              <v-text-field
                                label="مدة المكالمة إلى (بالثواني)"
                                v-model="callsDurationTo"
                                outlined
                                dense
                                type="number"
                                min="0"
                                inputmode="numeric"
                              />
                            </v-col>
                            <v-col cols="12" sm="4" md="4" v-if="isHasCalls === 'نعم'">
                              <PickerInput
                                label="تاريخ المكالمة من"
                                @dateValue="saveCallDateFrom"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="4" md="4" v-if="isHasCalls === 'نعم'">
                              <PickerInput
                                label="تاريخ المكالمة الي"
                                @dateValue="saveCallDateTo"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="4" md="4">
                              <SelectInput
                                ref="selectInput3"
                                @selectedValues="getSelectedProductType"
                                :originalItems="productType"
                                label="نوع المنتج"
                              />
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                              <SelectInput
                                ref="selectInput4"
                                @selectedValues="getRequestStatus"
                                :originalItems="requestTypeDrop"
                                label="حاله الطلب"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4">
                              <v-autocomplete
                                :items="noteType"
                                label="حاله الملاحظه"
                                v-model="getRequestsType"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput5"
                                @selectedValues="getSourceWork"
                                :originalItems="requestSource"
                                label="مصدر المعامله"
                              />
                            </v-col>
                            
                            <v-col cols="12" lg="4" md="6" class="pb-5 pt-0"  v-if="sourceWork.find((el) => {return el.id == 2} )">
                              <v-autocomplete
                                placeholder="المتعاونين"
                                label="المتعاونين"
                                hide-details
                                :items="collaborators"
                                class="mr-1"
                                item-text="name"
                                item-value="collaborator_id"
                                v-model="selected_collaborators"
                                outlined
                                multiple
                                dense
                                chips
                                deletable-chips
                                color="primary"
                                append-icon
                              ></v-autocomplete>
                          
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput6"
                                @selectedValues="getTypeRequest"
                                :originalItems="typeRequest"
                                label="نوع الطلب"
                              />
                            </v-col>
                            <v-col cols="12" sm="12" md="12"  v-if="sourceWork.find((el) => {return el.id == 2} )">
                              <v-text-field
                                v-model="platform_note"
                                label="بحث في الملاحظات"
                                outlined
                                dense
                                clearable
                                class="mt-2"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput7"
                                @selectedValues="getRejectionList"
                                :originalItems="rejection_lists"
                                label="أسباب الرفض"
                              />
                            </v-col>
                            
                            <v-col cols="12" sm="12" md="12" >
                              <SelectInput
                                ref="selectInput7"
                                @selectedValues="getRequestDescription"
                                :originalItems="request_descriptions"
                                label="وصف الطلب"
                              />
                            </v-col>
                           
                           
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput1"
                                label="تاريخ الطلب من"
                                @dateValue="saveDateFrom"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput2"
                                label="تاريخ الطلب الي"
                                @dateValue="saveDateTo"
                              />
                            </v-col>
  
                            <!--متي يظبط وضعه  -->
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput1"
                                label="متي يظبط وضعه من"
                                @dateValue="situationImproveDateForm"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput2"
                                label="متي يظبط وضعه الي"
                                @dateValue="situationImproveDateTo"
                              />
                            </v-col>
                            <!--  -->
  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput3"
                                label="تاريخ الأفراغ من"
                                @dateValue="saveCompleteDateFrom"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput4"
                                label="تاريخ الأفراع الي"
                                @dateValue="saveCompleteDateTo"
                              />
                            </v-col>
  
                            <!-- ======================================================== -->
                             
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput5"
                                label="تاريخ نزول الطلب فى سله المبيعات من"
                                info="اخر تاريخ نزول الطلب فى سله المبيعات"
                                @dateValue="saveAdminDateFrom"
                              />
                            </v-col>

  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput6"
                                label="تاريخ نزول الطلب فى سله المبيعات الي"
                                info="اخر تاريخ نزول الطلب فى سله المبيعات"
                                @dateValue="saveAdminDateTo"
                              />
                            </v-col>
                            <!-- ======================================================== -->
                            
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput7"
                                label="تاريخ نزول الطلب للاستشارى من"
                                @dateValue="saveAgentDateFrom"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput8"
                                label="تاريخ نزول الطلب للاستشارى الي"
                                @dateValue="saveAgentDateTo"
                              />
                            </v-col>
                            <!-- ======================================================== -->
                            <v-col
                              cols="12"
                              lg="12"
                              style="padding-top: 0px; margin-bottom: 15px"
                            >
                              <input
                                type="checkbox"
                                :checked="updatedDate"
                                @change="handleToggle"
                              />
                              <label
                                for="vehicle1"
                                style="margin-right: 10px"
                                v-if="updatedDate"
                                >التي تم التحديث عليها</label
                              >
                              <label
                                for="vehicle1"
                                style="margin-right: 10px"
                                v-if="!updatedDate"
                                >تاريخ عدم التحديث</label
                              >
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6" v-if="updatedDate">
                              <PickerInput label="من تاريخ" @dateValue="saveUpdatedFrom" />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6" v-if="updatedDate">
                              <PickerInput
                                label="الي تاريخ"
                                @dateValue="saveUpdatedTo"
                                ref="pickerInput5"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="12" md="12" v-if="!updatedDate">
                              <PickerInput
                                label="من تاريخ"
                                @dateValue="saveUnUpdatedTo"
                                ref="pickerInput6"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput20"
                                @selectedValues="getworkList"
                                :originalItems="workList"
                                label="جهه العمل"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput8"
                                @selectedValues="getSalaryList"
                                :originalItems="salaryList"
                                label="جهه تزول الراتب"
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput9"
                                @selectedValues="getFundingSide"
                                :originalItems="fundingSide"
                                label="جهه التمويل"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput21"
                                @selectedValues="getMortgageCustomerNeeds"
                                :originalItems="customerNeeds"
                                label="احتياجات العميل"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput22"
                                @selectedValues="getMortgageCustomerObjections"
                                :originalItems="CustomerObjections"
                                label="الاعتراضات والتحديات"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="4">
                              <SelectInput
                                ref="selectInput23"
                                @selectedValues="getMortgageObstacles"
                                :originalItems="CustomerObsatacles"
                                label="المعوقات"
                              />
                            </v-col>

                            <!-- ======================================================== -->
                            <v-col cols="12" sm="6" md="4">
                              <v-select
                                :items="filteredHamlaSource"
                                label="سورس الحملة"
                                v-model="selectedHamlaSource"
                                :menu-props="{ maxHeight: 360, offsetY: true, contentClass: referralMenuClass }"
                                clearable
                                outlined
                                dense
                              >
                                <template v-slot:prepend-item>
                                  <v-list-item class="hamla-source-search">
                                    <v-text-field
                                      v-model="hamlaSourceSearch"
                                      label="بحث"
                                      prepend-inner-icon="mdi-magnify"
                                      hide-details
                                      clearable
                                      dense
                                      outlined
                                      @click.stop
                                      @mousedown.stop
                                      @keydown.stop
                                    ></v-text-field>
                                  </v-list-item>
                                  <v-divider class="mt-2"></v-divider>
                                </template>
                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-title>لا توجد نتائج مطابقة</v-list-item-title>
                                  </v-list-item>
                                </template>
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-select>
                            </v-col>
                            <!-- ======================================================== -->
                            <v-col cols="12" sm="12" md="8">
                              <v-select
                                :items="filteredReferrals"
                                item-text="name"
                                item-value="id"
                                label="الحملة"
                                v-model="selectedReferral"
                                :menu-props="{ maxHeight: 360, offsetY: true, contentClass: referralMenuClass }"
                                clearable
                                outlined
                                dense
                              >
                                <template v-slot:prepend-item>
                                  <v-list-item class="referral-search">
                                    <v-text-field
                                      v-model="referralSearch"
                                      label="بحث بالاسم أو الرابط"
                                      prepend-inner-icon="mdi-magnify"
                                      hide-details
                                      clearable
                                      dense
                                      outlined
                                      @click.stop
                                      @mousedown.stop
                                      @keydown.stop
                                    ></v-text-field>
                                  </v-list-item>
                                  <v-divider class="mt-2"></v-divider>
                                </template>
                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-title>لا توجد نتائج مطابقة</v-list-item-title>
                                  </v-list-item>
                                </template>
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on" class="referral-option">
                                    <v-list-item-content>
                                      <v-list-item-title
                                        :id="attrs['aria-labelledby']"
                                        class="referral-option-name"
                                      >{{ item.name }}</v-list-item-title>
                                      <v-list-item-subtitle
                                        v-if="item.url"
                                        class="referral-option-url"
                                        dir="ltr"
                                      >{{ item.url }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                                <template v-slot:selection="{ item }">
                                  <span>{{ item.name }}</span>
                                </template>
                              </v-select>
                            </v-col>
                            <!-- ======================================================== -->
                            
                          </v-row>
                        </v-form>
                      </div>
                    </v-tab-item>
  
                    <v-tab-item>
                      <div class="panalContextFilter">
                        <v-form style="margin-top: 20px">
                          <v-row>
                            <v-col cols="12">
                              <IncludeDeletedClassificationsToggle v-model="includeDeletedClassifications" />
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                :items="allTypes"
                                label="جميع التصنيفات"
                                v-model="allType"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                ref="selectInput10"
                                @selectedValues="getSelectedAgentType"
                                :originalItems="selesAgentType"
                                label="تصنيف استشاري المبيعات"
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="6" v-if="selectAgentType.some(ele => Number(ele.is_rejected) === 1)">
                              <SelectInput
                                ref="selectInput19"
                                @selectedValues="getSelectAgentRefused"
                                :originalItems="selesAgentRefuseList"
                                label="سبب الرفض"
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                ref="selectInput11"
                                @selectedValues="getSelectedMangerType"
                                :originalItems="selesMangerType"
                                label="تصنيف مدير المبيعات"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                ref="selectInput12"
                                @selectedValues="getSelectedFundingType"
                                :originalItems="fundingMangerType"
                                label="تصنيف مشرف التمويل"
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                ref="selectInput13"
                                @selectedValues="getMerteryType"
                                :originalItems="marteryMangerType"
                                label="تصنيف مدير الرهن"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                ref="selectInput14"
                                @selectedValues="getGeneralManger"
                                :originalItems="genaralMangerType"
                                label="تصنيف المدير العام"
                              />
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                ref="selectInput26"
                                @selectedValues="getSelectedCustomerServiceClassification"
                                :originalItems="csAgentType"
                                label="تصنيف خدمة العملاء"
                              />
                            </v-col>

                          </v-row>
                        </v-form>
                      </div>
                    </v-tab-item>

                    <!-- خدمة العملاء tab -->
                    <v-tab-item>
                      <div class="panalContextFilter">
                        <v-form style="margin-top: 20px">
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                @selectedValues="getSelectedCustomerService"
                                :originalItems="customerServiceAgents"
                                label="خدمة العملاء"
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                ref="selectInput25"
                                @selectedValues="getSelectedCustomerServiceClassification"
                                :originalItems="csAgentType"
                                label="تصنيف خدمة العملاء"
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                label="جزء من ملاحظة خ ع"
                                v-model="customerServiceNote"
                                outlined
                                dense
                              />
                            </v-col>

                            <!-- =========================================== -->
                             <!-- في فلتر جميع الطلبات عند الادمن ومدير المبيعات يكون في خانة اسمها لدى خدمة العملاء بجواب نعم و لا حيث نعم تعني الطلب مر على خدمة العملاء -->
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                :items="['لا', 'نعم']"
                                label=" لدى خدمة العملاء"
                                v-model="isCustomerServiceReview"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <!-- =========================================== -->


                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput12"
                                label="تاريخ نزول الطلب خ ع من"
                                @dateValue="saveCsDateFrom"
                              />
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput13"
                                label="تاريخ نزول الطلب خ ع إلي"
                                @dateValue="saveCsDateTo"
                              />
                            </v-col>
                          </v-row>
                        </v-form>
                      </div>
                    </v-tab-item>

                    <v-tab-item>
                      <div class="panalContextFilter">
                        <v-form style="margin-top: 20px">
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                label="الهاتف"
                                v-model="phoneNumber"
                                outlined
                                v-numericOnly
                                dense
                              ></v-text-field>
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                :items="['غير سعودي', 'سعودي']"
                                label="الجنسية"
                                v-model="selectedNationality"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                :items="['شركة','مؤسسة','فرد']"
                                label="لديه"
                                v-model="selectedYouHave"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                :items="['نقاط بيع','قوائم مالية','راتب فقط','أمتلك منشأة تجارية','أمتلك عقار','لا يوجد']"
                                label="مصدر الدخل"
                                v-model="selectedSourceOfIncome"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                :items="['نعم','لا']"
                                label="هل لديه راتب"
                                v-model="selectedHaveSalary"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
  
  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput7"
                                label="تاريخ الميلاد"
                                @dateValue="saveBirthDate"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                label="راتب العميل من"
                                v-model="salaryFrom"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field
                                label="راتب العميل الي"
                                v-model="salaryTo"
                                outlined
                                dense
                              ></v-text-field>
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                ref="selectInput15"
                                @selectedValues="getSelectedRegionValue"
                                :originalItems="selectedRegion"
                                label="منطقه العميل"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                :items="['لا', 'نعم']"
                                label="هل وجد عقار"
                                v-model="isHasProperty"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                :items="['لا', 'نعم']"
                                label="تم تحميل التطبيق"
                                v-model="isAplicationInstal"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </v-form>
                      </div>
                    </v-tab-item>
  
                    <v-tab-item>
                      <div class="panalContextFilter">
                        <v-form style="margin-top: 20px">
                          <v-row>
                            <v-col cols="10" sm="10" md="10">
                              <SelectInput
                                ref="selectInput16"
                                @selectedValues="getQuality"
                                :originalItems="quality"
                                label="الجوده"
                              />
                            </v-col>
  
                         <v-col cols="2" sm="2" md="2" class="d-flex align-center">
                            <v-checkbox
                              v-model="includeAll"
                              label="الجميع"
                              @change="getSupAdmin"
                              hide-details
                              density="compact"
                            />
                          </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                :items="['لا', 'نعم']"
                                label="استلامه من قبل الجوده"
                                v-model="resiveFromQuality"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-autocomplete
                                :items="['لا', 'نعم']"
                                label="ارشفه من قبل الجوده"
                                v-model="qualityArchive"
                                outlined
                                dense
                              >
                                <template v-slot:item="{ item, attrs, on }">
                                  <v-list-item v-bind="attrs" v-on="on">
                                    <v-list-item-title
                                      :id="attrs['aria-labelledby']"
                                      v-text="item"
                                    ></v-list-item-title>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                ref="selectInput17"
                                @selectedValues="getQualityType"
                                :originalItems="qualityStatus"
                                label="حاله الطلب عند الجوده"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <SelectInput
                                ref="selectInput18"
                                @selectedValues="getVarityQuality"
                                :originalItems="qualityUserType"
                                label="تصنيف الجوده"
                              />
                            </v-col>
                          </v-row>
                        </v-form>
                      </div>
                    </v-tab-item>
  
                    <v-tab-item>
                      <div class="panalContextFilter">
                        <v-form style="margin-top: 20px">
                          <v-row>
  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput8"
                                label="تاريخ الدخول من"
                                @dateValue="saveRecievedDateFromReport"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput9"
                                label="تاريخ الدخول الي"
                                @dateValue="saveRecievedDateToReport"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput10"
                                label="تاريخ الخروج من"
                                @dateValue="saveExitDateFromReport"
                              />
                            </v-col>
  
                            <v-col cols="12" sm="6" md="6">
                              <PickerInput
                                ref="pickerInput11"
                                label="تاريخ الخروج الي"
                                @dateValue="saveExitDateToReport"
                              />
                            </v-col>
                            
                          </v-row>
                        </v-form>
                      </div>
                    </v-tab-item>
                  </v-tabs-items>

                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
       <v-card-actions
          style="
            display: flex; 
            justify-content: space-between;
            position: sticky;
            bottom: 0;
            background: white;
            z-index: 10;
            border-top: 1px solid #e0e0e0;
            padding: 16px;
          "
          class="mt-3"
        >
          <!-- <v-spacer></v-spacer> -->
          <div>
            <v-btn color="blue-darken-1" variant="text" @click="removeFilter">
              حذف الفلتر
            </v-btn>
          </div>
          <div>
            <v-btn
              color="blue-darken-1"
              variant="text"
              class="ml-2"
              @click="$store.state.search_admin = false"
            >
              الغاء
            </v-btn>
            <v-tooltip bottom open-on-click :open-on-hover="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="blue-darken-1"
                  v-bind="attrs"
                  v-on="on"
                  style="margin-inline: 4px"
                  @click.stop
                >
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>
              </template>
              <div style="max-width: 420px">
                <div v-if="filledFilters.length === 0">لا توجد قيم بحث مُعبأة</div>
                <div v-else>
                  <div
                    v-for="item in filledFilters"
                    :key="item.key"
                    style="margin-bottom: 6px"
                  >
                    <strong>{{ item.label }}:</strong>
                    <span>{{ item.value }}</span>
                  </div>
                </div>
              </div>
            </v-tooltip>
            <v-btn color="blue-darken-1" variant="text" @click="searchRequest">
              بحث
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Dialog from "../../mixins/dialog";
import SelectInput from "@/components/Charts/SelectInput.vue";
import PickerInput from "@/components/AdminComponent/PickerInput.vue";
import { removeDuplicated } from "@/mixins/removeDublicated";
import { SourceValue } from "@/mixins/sourceValue";
import { formatDate } from "@/mixins/formatDate";
import { SearchIconBlack } from "@/assets/adminIcons/searchIconBlack";
import { SearchIconWhite } from "@/assets/adminIcons/searchIconWhite";
import { axiosInstance } from "@/axios/config";
import { buildRequestAgentCsTableFields } from "@/helper/requestDisplayNames";
import { buildReferralUrl, normalizeReferralUrl } from "@/utils/referralUrl";
import classificationFilterMixin from "@/mixins/classificationFilterMixin";
import { buildClassificationFilterUrl } from "@/helper/classificationFilterHelper";
import IncludeDeletedClassificationsToggle from "@/components/Filters/IncludeDeletedClassificationsToggle.vue";

export default {
  components: { PickerInput, SelectInput, SearchIconBlack, SearchIconWhite, IncludeDeletedClassificationsToggle },
  mixins: [Dialog, classificationFilterMixin],
  props: ["pageName"],

  data() {
    return {
      body: {},
      disabled: false,
      filterType: "إسم العميل",
      panel: 0,
      // Used by the "filled values" tooltip beside the search button
      // (kept as state to allow click-open behavior in Vuetify 2 tooltip)
      showFilledValuesTooltip: false,
      filterTypeParts: "",
      allStatus: ["الكل", "استشاري مؤرشف", "استشاري قائم"],
      allTypes: ["جميع التصنيفات", "ايجابي", "سلبي","بدون"],
      typeRequest: [],
      allType: "",
      noteType: ["بها محتوي", "فارغه"],
      allMangerType: ["general", "gen"],
      allMangers: [],
      allAgents: [],
      allFundingManagers: [],
      selectedStatusFilter: "الكل",
      selectedAcceptArchivedOrNot: "الكل",
      selectedManger: [],
      selectedMang: [],
      selesAgentType: [],
      // خدمة العملاء pool — filters on class_id_cs, not class_id_agent.
      csAgentType: [],
      selesAgentRefuseList: [],
      selesMangerType: [],
      fundingMangerType: [],
      marteryMangerType: [],
      genaralMangerType: [],
      qualityUserType: [],
      selectAgent: [],
      AgentBeforeSendingToAdministration: [],
      fundingManagers: [],
      salaryFrom: "",
      salaryTo: "",
      requestStatu: [],
      selectedRequestStatus: [],
      requestSource: [],
      platform_note: "",
      collaborators: [],
      selected_collaborators: [],
      selectedRegion: [],
      hamlaSource: [],
      sourceWork: [],
      phoneNumber: "",
      selectAgentType: [],
      selectAgentRefused: [],
      selectedSalesManger: [],
      selectedFundingManger: [],
      selectMortgageManger: [],
      selectGeneralManger: [],
      selectCustomerServiceClassification: [],
      productType: [],
      selectedProductType: [],
      requestTypeDrop: [],
      birthDate: "",
      selectBirthData: null,
      counter: 0,
      isAplicationInstal: "",
      getRequestsType: "",
      selectedRegionList: [],
      selectedTypeRequest: [],
      requestDateFrom: "",
      situation_improve_date_from: "",
      situation_improve_date_to: "",

      ExitDateFromReport: "",
      ExitDateToReport: "",
      RecievedDateFromReport: "",
      RecievedDateToReport: "",

      requestDateTo: "",
      completeDateFrom: "",
      completeDateTo: "",
      updatedDate: false,
      updatedDateFrom: "",
      updatedDateTo: "",
      UnUpdatedDate: "",
      adminDateFrom: "",
      adminDateTo: "",
      agentDateFrom: "",
      agentDateTo: "",
      workList: [],
      selectedWorkList: [],

      customerNeeds: [],
      rejection_lists: [],
      request_descriptions: [],
      CustomerObjections: [],
      CustomerObsatacles: [],

      selectedCustomerNeeds: [],
      selectedRejection_lists: [],
      selectedRequest_descriptions: [],
      selectedCustomerObjections: [],
      selectedCustomerObsatacles: [],


      salaryList: [],
      selectedSalaryList: [],
      fundingSide: [],
      selectedFundingSide: [],
      quality: [],
      includeAll: false,
      selectedQualityUsers: [],
      resiveFromQuality: "",
      isHasProperty: "",
      isHasCalls: "",
      qualityArchive: "",
      selectedVarityQuality: [],
      qualityStatus: [],
      selectedQualityStatus: [],

      selected_products_list: [],
      requestsCount: 0,
      typesCount: 0,
      clientCount: 0,
      qualityCount: 0,
      selectedNationality : "",
      PossibleToSellToCustomer : "",

      selectedYouHave : "",
      selectedSourceOfIncome : "",
      selectedHamlaSource: "",
      hamlaSourceSearch: "",
      referrals: [],
      selectedReferral: null,
      referralSearch: "",
      selectedHaveSalary : "",
      callsDateFrom: "",
      callsDateTo: "",
      callsDurationFrom: "",
      callsDurationTo: "",
      callConsultants: [],
      selectedCustomerService: [],
      customerServiceNote: "",
      isCustomerServiceReview:"",
      csDateFrom: "",
      csDateTo: "",

    };
  },
  computed: {
    // The campaign-source menu carries its own search box (prepend-item), so the
    // list is narrowed here rather than by v-autocomplete's built-in filter.
    filteredHamlaSource() {
      const query = (this.hamlaSourceSearch || "").toString().trim().toLowerCase();
      if (!query) return this.hamlaSource;
      const matches = this.hamlaSource.filter((item) =>
        String(item).toLowerCase().includes(query)
      );
      // v-select resolves the chip label from `items`, so a narrowed list must
      // still carry the picked value or the field renders empty while filtering.
      if (this.selectedHamlaSource && !matches.includes(this.selectedHamlaSource)) {
        matches.unshift(this.selectedHamlaSource);
      }
      return matches;
    },
    // The campaign menu carries its own search box (prepend-item) too, and it
    // matches the campaign name as well as the link — a browser URL pasted whole
    // is normalised the same way the campaigns CRUD normalises it, so it still
    // matches the suffix the row actually stores.
    filteredReferrals() {
      const raw = (this.referralSearch || "").toString().trim();
      if (!raw) return this.referrals;
      const selected = this.referrals.find((item) => item.id === this.selectedReferral);
      const query = raw.toLowerCase();
      const asUrl = normalizeReferralUrl(raw);
      const matches = this.referrals.filter(
        (item) => item.search.includes(query) || (asUrl && item.search.includes(asUrl))
      );
      if (selected && !matches.some((item) => item.id === selected.id)) {
        matches.unshift(selected);
      }
      return matches;
    },
    isDark() {
      return !!(this.$store && this.$store.getters && this.$store.getters.isDark);
    },
    referralMenuClass() {
      return this.isDark ? "referral-menu referral-menu--dark" : "referral-menu referral-menu--light";
    },
    getManagerNames() {
      return this.allMangers;
    },

    getAgentsName() {
      return this.allAgents;
    },

    getFundingManagersName() {
      return this.allFundingManagers;
    },

    tabCounts() {
      const isFilled = (val) => {
        if (Array.isArray(val)) return val.length > 0;
        if (val === null || val === undefined) return false;
        if (typeof val === "string") return val.trim().length > 0;
        if (typeof val === "number") return !Number.isNaN(val);
        if (typeof val === "boolean") return val === true;
        return !!val;
      };

      const count = (conds) => conds.filter(Boolean).length;

      return {
        requests: count([
          isFilled(this.filterTypeParts),
          isFilled(this.PossibleToSellToCustomer),
          this.selectedStatusFilter && this.selectedStatusFilter !== "الكل",
          this.selectedAcceptArchivedOrNot && this.selectedAcceptArchivedOrNot !== "الكل",
          isFilled(this.isHasCalls),
          isFilled(this.callsDateFrom),
          isFilled(this.callsDateTo),
          isFilled(this.callsDurationFrom),
          isFilled(this.callsDurationTo),
          isFilled(this.callConsultants),
          isFilled(this.selectedCustomerService),
          isFilled(this.selectedMang),
          isFilled(this.selectAgent),
          isFilled(this.selected_collaborators),
          isFilled(this.selectedReferral),
          isFilled(this.platform_note),
          isFilled(this.AgentBeforeSendingToAdministration),
          isFilled(this.fundingManagers),
          isFilled(this.selectedRequestStatus),
          isFilled(this.sourceWork),
          isFilled(this.selectedProductType),
          isFilled(this.selectedTypeRequest),
          isFilled(this.selectedWorkList),
          isFilled(this.selectedSalaryList),
          isFilled(this.getRequestsType),
          isFilled(this.requestDateFrom),
          isFilled(this.requestDateTo),
          isFilled(this.completeDateFrom),
          isFilled(this.completeDateTo),
          isFilled(this.updatedDateFrom),
          isFilled(this.updatedDateTo),
          isFilled(this.UnUpdatedDate),
          isFilled(this.adminDateFrom),
          isFilled(this.adminDateTo),
          isFilled(this.agentDateFrom),
          isFilled(this.agentDateTo),
          isFilled(this.situation_improve_date_from),
          isFilled(this.situation_improve_date_to),
          isFilled(this.selectedCustomerNeeds),
          isFilled(this.selectedRejection_lists),
          isFilled(this.selectedRequest_descriptions),
          isFilled(this.selectedCustomerObjections),
          isFilled(this.selectedCustomerObsatacles),
        ]),
        types: count([
          isFilled(this.allType),
          isFilled(this.selectAgentType),
          isFilled(this.selectAgentRefused),
          isFilled(this.selectedSalesManger),
          isFilled(this.selectedFundingManger),
          isFilled(this.selectMortgageManger),
          isFilled(this.selectGeneralManger),
          isFilled(this.selectCustomerServiceClassification),
        ]),
        client: count([
          isFilled(this.phoneNumber),
          isFilled(this.selectedNationality),
          isFilled(this.selectedYouHave),
          isFilled(this.selectedSourceOfIncome),
          isFilled(this.selectedHamlaSource),
          isFilled(this.selectedHaveSalary),
          isFilled(this.birthDate),
          isFilled(this.salaryFrom),
          isFilled(this.salaryTo),
          isFilled(this.selectedRegionList),
          isFilled(this.isHasProperty),
          isFilled(this.isAplicationInstal),
        ]),
        quality: count([
          isFilled(this.selectedQualityUsers),
          isFilled(this.resiveFromQuality),
          isFilled(this.qualityArchive),
          isFilled(this.selectedQualityStatus),
          isFilled(this.selectedVarityQuality),
        ]),
        fundingAvg: count([
          isFilled(this.RecievedDateFromReport),
          isFilled(this.RecievedDateToReport),
          isFilled(this.ExitDateFromReport),
          isFilled(this.ExitDateToReport),
        ]),
        cs: count([
          isFilled(this.selectedCustomerService),
          isFilled(this.selectCustomerServiceClassification),
          isFilled(this.customerServiceNote),
          isFilled(this.isCustomerServiceReview),
          isFilled(this.csDateFrom),
          isFilled(this.csDateTo),
        ]),
      };
    },

    filledFilters() {
      const items = [];

      const formatList = (list) =>
        (Array.isArray(list) ? list : [])
          .map((x) => {
            if (x == null) return "";
            if (typeof x === "string" || typeof x === "number") return String(x);
            return (
              x.text ||
              x.value ||
              x.title ||
              x.name ||
              x.mobile ||
              x.id ||
              JSON.stringify(x)
            );
          })
          .filter(Boolean)
          .join("، ");

      const push = (key, label, value) => {
        if (value === null || value === undefined) return;
        if (Array.isArray(value) && value.length === 0) return;
        if (typeof value === "string" && value.trim() === "") return;
        items.push({ key, label, value });
      };

      push("filterTypeParts", `جزء من ${this.filterType}`, this.filterTypeParts);
      push("PossibleToSellToCustomer", "هل بالامكان البيع للعميل؟", this.PossibleToSellToCustomer);
      if (this.selectedStatusFilter && this.selectedStatusFilter !== "الكل") {
        push("selectedStatusFilter", "الحالة", this.selectedStatusFilter);
      }
      if (this.selectedAcceptArchivedOrNot && this.selectedAcceptArchivedOrNot !== "الكل") {
        push("selectedAcceptArchivedOrNot", "الموافقه علي الارشفة ؟", this.selectedAcceptArchivedOrNot);
      }
      push("isHasCalls", "طلبات تحتوي علي مكالمات", this.isHasCalls);
      push("callsDateFrom", "تاريخ المكالمة من", this.callsDateFrom);
      push("callsDateTo", "تاريخ المكالمة إلى", this.callsDateTo);
      push("callsDurationFrom", "مدة المكالمة من", this.callsDurationFrom);
      push("callsDurationTo", "مدة المكالمة إلى", this.callsDurationTo);
      push("selectedCustomerService", "خدمة العملاء", formatList(this.selectedCustomerService));
      push("callConsultants", "استشاري المكالمة", formatList(this.callConsultants));

      push("selectedMang", "مدير المبيعات", formatList(this.selectedMang));
      push("fundingManagers", "مدير التمويل", formatList(this.fundingManagers));
      push("selectAgent", "استشاري المبيعات", formatList(this.selectAgent));
      push("platform_note", "ملاحظة المنصة", this.platform_note);
      push("selectedProductType", "نوع المنتج", formatList(this.selectedProductType));
      push("selectedRequestStatus", "حاله الطلب", formatList(this.selectedRequestStatus));
      push("getRequestsType", "حاله الملاحظه", this.getRequestsType);
      push("requestDateFrom", "تاريخ الطلب من", this.requestDateFrom);
      push("requestDateTo", "تاريخ الطلب إلى", this.requestDateTo);
      push("completeDateFrom", "تاريخ الاكتمال من", this.completeDateFrom);
      push("completeDateTo", "تاريخ الاكتمال إلى", this.completeDateTo);
      push("updatedDateFrom", "تاريخ التحديث من", this.updatedDateFrom);
      push("updatedDateTo", "تاريخ التحديث إلى", this.updatedDateTo);
      push("UnUpdatedDate", "بدون تحديث منذ", this.UnUpdatedDate);
      push("situation_improve_date_from", "تاريخ تحسن الحالة من", this.situation_improve_date_from);
      push("situation_improve_date_to", "تاريخ تحسن الحالة إلى", this.situation_improve_date_to);

      push("adminDateFrom", "تاريخ نزول الطلب فى سله المبيعات من", this.adminDateFrom);
      push("adminDateTo", "تاريخ نزول الطلب فى سله المبيعات الي", this.adminDateTo);
      push("agentDateFrom", "تاريخ نزول الطلب للاستشارى من", this.agentDateFrom);
      push("agentDateTo", "تاريخ نزول الطلب للاستشارى الي", this.agentDateTo);

      push("allType", "جميع التصنيفات", this.allType);
      push("selectAgentType", "تصنيف استشاري المبيعات", formatList(this.selectAgentType));
      push("selectAgentRefused", "سبب الرفض", formatList(this.selectAgentRefused));
      push("selectedSalesManger", "تصنيف مدير المبيعات", formatList(this.selectedSalesManger));
      push("selectedFundingManger", "تصنيف مشرف التمويل", formatList(this.selectedFundingManger));
      push("selectMortgageManger", "تصنيف مدير الرهن", formatList(this.selectMortgageManger));
      push("selectGeneralManger", "تصنيف المدير العام", formatList(this.selectGeneralManger));
      push("selectCustomerServiceClassification", "تصنيف خدمة العملاء", formatList(this.selectCustomerServiceClassification));
      push("customerServiceNote", "جزء من ملاحظة خ ع", this.customerServiceNote);
      push("isCustomerServiceReview", " لدى خدمة العملاء", this.isCustomerServiceReview);
      push("csDateFrom", "تاريخ نزول الطلب خ ع من", this.csDateFrom);
      push("csDateTo", "تاريخ نزول الطلب خ ع إلي", this.csDateTo);

      push("phoneNumber", "الهاتف", this.phoneNumber);
      push("selectedNationality", "الجنسية", this.selectedNationality);
      push("selectedYouHave", "لديه", this.selectedYouHave);
      push("selectedSourceOfIncome", "مصدر الدخل", this.selectedSourceOfIncome);
      push("selectedHamlaSource", "سورس الحملة", this.selectedHamlaSource);
      const selectedReferralItem = this.referrals.find(
        (item) => item.id === this.selectedReferral
      );
      push("selectedReferral", "الحملة", selectedReferralItem ? selectedReferralItem.name : "");
      push("selectedHaveSalary", "هل لديه راتب", this.selectedHaveSalary);
      push("birthDate", "تاريخ الميلاد", this.birthDate);
      push("salaryFrom", "راتب العميل من", this.salaryFrom);
      push("salaryTo", "راتب العميل إلى", this.salaryTo);
      push("selectedRegionList", "منطقه العميل", formatList(this.selectedRegionList));
      push("isHasProperty", "هل وجد عقار", this.isHasProperty);
      push("isAplicationInstal", "تم تحميل التطبيق", this.isAplicationInstal);

      push("selectedQualityUsers", "الجوده", formatList(this.selectedQualityUsers));
      push("resiveFromQuality", "استلامه من قبل الجوده", this.resiveFromQuality);
      push("qualityArchive", "ارشفه من قبل الجوده", this.qualityArchive);
      push("selectedQualityStatus", "حاله الطلب عند الجوده", formatList(this.selectedQualityStatus));
      push("selectedVarityQuality", "تصنيف الجوده", formatList(this.selectedVarityQuality));

      push("RecievedDateFromReport", "تاريخ الدخول من", this.RecievedDateFromReport);
      push("RecievedDateToReport", "تاريخ الدخول إلى", this.RecievedDateToReport);
      push("ExitDateFromReport", "تاريخ الخروج من", this.ExitDateFromReport);
      push("ExitDateToReport", "تاريخ الخروج إلى", this.ExitDateToReport);

      return items;
    },

    salesAgentsOnly() {
      return (this.allAgents || []).filter(
        (a) => Number(a.role) === 0 && Number(a.is_customer_service) !== 1
      );
    },

    customerServiceAgents() {
      return (this.allAgents || []).filter(
        (a) => Number(a.role) === 0 && Number(a.is_customer_service) === 1
      );
    },
    
  },

  watch: {
    selectedStatusFilter(val) {
      if (val === "الكل") {
        this.getAllManger("manager");
        this.getAllAgents("agent", 1, this.selectedMang);
      } else if (val === "استشاري مؤرشف") {
        this.getAllAgents("agent", 0, this.selectedMang);
        this.getAllManger("manager ", 0);
      } else if (val === "استشاري قائم") {
        this.getAllAgents("agent", 1, this.selectedMang);
        this.getAllManger("manager ", 1);
      }
    },

    "selectedProductType": function (newVal, oldVal) {
      if (oldVal !== newVal) {
        this.get_rejection_list(newVal[0].id);
      }
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (this.$store.state.admin_search_active && newval !== oldvalue && newval.length > 1) {
          this.searchRequest();
          
        }
      },
    },
    "$store.state.rejection_list": {
      handler(newval, oldvalue) {
        this.selesAgentRefuseList = newval.map(item => ({
                id: item.id,
                text: item.title, // Renaming title to value
                value: item.title, // Renaming title to value
                color: "orange" // Renaming title to value
              }));

              console.log("this.selesAgentRefuseList", this.selesAgentRefuseList)
      },
    },
  },

  methods: {
    removeFilter() {
      this.$store.state.CustomerNameOrComment = '';
      this.$store.state.admin_search_active = false;
      this.requestsCount = 0;
      this.typesCount = 0;
      this.clientCount = 0;
      this.qualityCount = 0;

      this.RecievedDateFromReport = "";
      this.RecievedDateToReport = "";
      this.ExitDateFromReport = "";
      this.ExitDateToReport = "";

      this.filterTypeParts = "";
      this.isHasProperty = "";
      this.phoneNumber = "";
      this.selectedStatusFilter = "الكل";
      this.selectedAcceptArchivedOrNot = "الكل";
      this.getRequestsType = "";
      this.allType = "";
      this.salaryFrom = "";
      this.salaryTo = "";
      this.isAplicationInstal = "";
      this.resiveFromQuality = "";
      this.qualityArchive = "";
      this.selectedNationality = "";
      this.PossibleToSellToCustomer = "";
      this.selectedYouHave = "";
      this.selectedSourceOfIncome = "";
      this.selectedHamlaSource = "";
      this.hamlaSourceSearch = "";
      this.selectedReferral = null;
      this.referralSearch = "";
      this.selectedHaveSalary = "";
      this.callsDateFrom = "";
      this.callsDateTo = "";
      this.callsDurationFrom = "";
      this.callsDurationTo = "";
      this.callConsultants = [];
      this.selectedCustomerService = [];
   
      this.adminDateFrom = "";
      this.adminDateTo = "";
      this.agentDateFrom = "";
      this.agentDateTo = "";

      this.selectCustomerServiceClassification = [];
      this.customerServiceNote = "";
      this.isCustomerServiceReview = "";
      this.csDateFrom = "";
      this.csDateTo = "";
      for (let i = 0; i <= 26; i++) {
        if (this.$refs[`selectInput${i}`] && this.$refs[`selectInput${i}`].clear) {
          this.$refs[`selectInput${i}`].clear();
        }
      }

      for (let i = 1; i <= 13; i++) {
        if (this.$refs[`pickerInput${i}`]) {
          this.$refs[`pickerInput${i}`].date = null;
        }
      }
    },
    getQualityType(val) {
      this.selectedQualityStatus = val;
    },

    getVarityQuality(val) {
      this.selectedVarityQuality = val;
    },
    getQuality(val) {
      this.selectedQualityUsers = val;
    },

    getFundingSide(val) {
      this.selectedFundingSide = val;
    },

    getSalaryList(val) {
      this.selectedSalaryList = val;
    },

    getworkList(val) {
      this.selectedWorkList = val;
    },

    getMortgageCustomerNeeds(val) {
      this.selectedCustomerNeeds = val;
    },

    getCallConsultants(val) {
      this.callConsultants = val;
    },

    getRejectionList(val) {
      this.selectedRejection_lists = val;
    },

    getRequestDescription(val) {
      this.selectedRequest_descriptions = val;
    },


    getMortgageObstacles(val) {
      this.selectedCustomerObsatacles = val;
    },

    getMortgageCustomerObjections(val) {
      this.selectedCustomerObjections = val;
    },

    saveUpdatedFrom(val) {
      this.updatedDateFrom = val;
    },

    getSelectedCustomerService(val) {
      this.selectedCustomerService = val;
    },

    saveCsDateFrom(val) {
      this.csDateFrom = val;
    },

    saveCsDateTo(val) {
      this.csDateTo = val;
    },

    saveUpdatedTo(val) {
      this.updatedDateTo = val;
    },

    saveUnUpdatedTo(val) {
      this.UnUpdatedDate = val;
    },

    handleToggle() {
      this.updatedDate = !this.updatedDate;
    },

    saveBirthDate(val) {
      this.birthDate = val;
    },

    saveDateFrom(val) {
      this.requestDateFrom = val;
    },

    saveCallDateFrom(val) {
      this.callsDateFrom = val;
    },

    saveCallDateTo(val) {
      this.callsDateTo = val;
    },

    situationImproveDateForm(val) {
      this.situation_improve_date_from = val;
    },

    situationImproveDateTo(val) {
      this.situation_improve_date_to = val;
    },


    saveExitDateFromReport(val) {
      this.ExitDateFromReport = val;
    },
    saveExitDateToReport(val) {
      this.ExitDateToReport = val;
    },
    saveRecievedDateFromReport(val) {
      this.RecievedDateFromReport = val;
    },
    saveRecievedDateToReport(val) {
      this.RecievedDateToReport = val;
    },


    saveDateTo(val) {
      this.requestDateTo = val;
    },

    saveCompleteDateFrom(val) {
      this.completeDateFrom = val;
    },

    saveCompleteDateTo(val) {
      this.completeDateTo = val;
    },

    // ========================================================
    saveAdminDateFrom(val) {
      this.adminDateFrom = val;
    },

    saveAdminDateTo(val) {
      this.adminDateTo = val;
    },
    // ========================================================
    saveAgentDateFrom(val) {
      this.agentDateFrom = val;
    },

    saveAgentDateTo(val) {
      this.agentDateTo = val;
    },
    // ========================================================

    requestStatus() {
      axiosInstance.get("/agent/RequestStatus").then((response) => {
        this.requestTypeDrop = response.data.payload.map((item) => {
          item["color"] = "red";
          item["text"] = item["value"];
          return item;
        });
      });
    },

    get_work_list() {
      // this.workList = this.$store.state.works_list.map((item) => {
      //   item["color"] = "red";
      //   item["text"] = item["value"];
      //   return item;
      // });
      axiosInstance.get("/customer/WorkSources").then((res) => {
        this.workList = res.data.payload.map((item) => {
          item["color"] = "red";
          item["text"] = item["value"];
          return item;
        });
      });
    },

    MortgageCustomerNeeds() {
      axiosInstance.get("/employee/admin/mortgage-settings-CustomerNeeds").then((res) => {
        this.customerNeeds = res.data.payload.map((item) => {
          item["color"] = "red";
          item["text"] = item["value"];
          return item;
        });
      });

    },

    // get_rejection_list() {
    //   axiosInstance.get("/agent/Rejections/Reasons").then((response) => {
    //     this.rejection_lists = response.data.payload.map((item) =>{
    //       item["color"] = "red";
    //       item["text"] = item["title"];
    //       return item;
    //     });
    //   });
    // },

    async get_rejection_list(productType) {
      let url = `/agent/Rejections/Reasons`;
      if(productType){
        url = `/agent/Rejections/Reasons?productType=${productType}`
      }
      await axiosInstance.get(url).then((response) => {
        this.rejection_lists = response.data.payload.map((item) =>{
          item["color"] = "red";
          item["text"] = item["title"];
          return item;
        });

      });
    },

    async get_request_description() {
      let url = `/employee/admin/requestDescription`;
      await axiosInstance.post(url).then((response) => {
        this.request_descriptions = response.data.payload.data.map((item) =>{
          item["color"] = "red";
          item["text"] = item["option"];
          return item;
        });

      });
    },

    MortgageCustomerObjections() {
      axiosInstance.get("/employee/admin/mortgage-settings-CustomerObjections").then((res) => {
        this.CustomerObjections = res.data.payload.map((item) => {
          item["color"] = "red";
          item["text"] = item["value"];
          return item;
        });
      });
    },

    MortgageCustomerObsatacles() {
      axiosInstance.get("/employee/admin/mortgage-settings-CustomerObsatacles").then((res) => {
        this.CustomerObsatacles = res.data.payload.map((item) => {
          item["color"] = "red";
          item["text"] = item["value"];
          return item;
        });
      });
    },

   
    getRequestSource() {
      axiosInstance.get("/agent/Request/Sources").then((res) => {
        this.requestSource = res.data.payload.map((item) => {
          item["color"] = "red";
          item["text"] = item["value"];
          return item;
        });
      });
    },

    getSelectedRegion() {
      axiosInstance.get("/agent/regions").then((res) => {
        this.selectedRegion = res.data.payload.map((item) => {
          item["color"] = "red";
          item["text"] = item["region_ip"];
          return item;
        });
      });
    },
    // ========================================================
    getHamlaSource() {
      console.log('getHamlaSource');
      axiosInstance.get("/employee/admin/hamla-sources").then((res) => {
        console.log('res', res.data.payload);
        this.hamlaSource = res.data.payload.map((item) => {
          return item;
        });
        console.log('this.hamlaSource', this.hamlaSource);
      });
    },
    // Every campaign in the referrals table, not only the ones a customer already
    // came through: the link campaigns carry no hamla_source, so they never show
    // up in the "سورس الحملة" list above. Each option keeps its full link (built
    // from website + suffix the same way the campaigns CRUD builds it) for the
    // second line of the row and for the search box.
    getReferrals() {
      axiosInstance
        .get("/employee/admin/referrals-crud/meta/options")
        .then((res) => {
          this.referrals = (res.data.payload || []).map((item) => {
            const url =
              [item.url1, item.url2]
                .filter((suffix) => suffix && !/\s/.test(String(suffix)))
                .map((suffix) => buildReferralUrl(item.website, suffix))
                .find((link) => /^https?:\/\//i.test(link)) || "";
            const name = item.name || item.username || `#${item.id}`;
            return {
              id: item.id,
              name,
              url,
              // one lowercase haystack per row: name, link (as shown and
              // normalised) and the sheet source the campaign is known by
              search: [name, url, normalizeReferralUrl(url), item.haml_source, item.username]
                .filter(Boolean)
                .join(" ")
                .toLowerCase(),
            };
          });
        })
        .catch(() => {
          this.referrals = [];
        });
    },
    // ========================================================

    get_salary_sources() {
      axiosInstance.get("/customer/SalarySources").then((res) => {
        this.salaryList = res.data.payload.map((item) => {
          item["color"] = "red";
          item["text"] = item["value"];
          return item;
        });
      });
    },

    getSelectedRegionValue(val) {
      this.selectedRegionList = val;
    },

    getRequestType() {
      this.requestTypeDrop = this.$store.state.request_statuses.map((item) => {
        item["color"] = "red";
        item["text"] = item["value"];
        return item;
      });
    },

    getSourceWork(val) {
      this.sourceWork = val;
      console.log("this.sourceWork", this.sourceWork, this.sourceWork.find((el) => {return el.id == 2} ));
    },

    searchRequest() {
      this.$store.state.isSearch = true;
      // this.$store.state.showCards = true;
      this.body = new FormData();
      this.$store.state.search_admin = false;

      this.$store.state.allRequests = [];
      this.$store.state.allSearch = [];
      this.$store.state.allData = [];
      this.$store.state.recievedSearch = [];
      this.$store.state.recievedData = [];
      this.$store.state.followSearch = [];
      this.$store.state.followData = [];
      this.$store.state.featureSearch = [];
      this.$store.state.featureData = [];
      this.$store.state.archiveSearch = [];
      this.$store.state.archiveData = [];
      this.$store.state.latestData = [];

      this.$store.state.tableData = [];
      this.$store.state.InfinityPageNumber = 1;

      this.$store.state.loadingData = true;
      this.$store.state.allLoading = true;
      this.$store.state.recievedLoading = true;
      this.$store.state.followLoading = true;
      this.$store.state.featureLoading = true;
      this.$store.state.archiveLoading = true;
      this.$store.state.latestLoading = true;

      this.$store.state.back = true;
      this.$store.state.startElement = [];
      this.$store.state.bodySearch = {};
      this.counter++;

      this.requestsCount = 0;
      this.typesCount = 0;
      this.clientCount = 0;
      this.qualityCount = 0;

      if (this.selectedMang.length > 0) {
        this.selectedMang.forEach((item, index) => {
          this.body.append(`sales_manager_ids[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.selectAgent.length > 0) {
        // update admin_filter
        //this.$store.state.admin_filter.selectAgent = this.selectAgent;
        this.selectAgent.forEach((item, index) => {
          this.body.append(`agent_name[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.selectedCustomerService.length > 0) {
        this.selectedCustomerService.forEach((item, index) => {
          const idx = this.selectAgent.length + index;
          this.body.append(`agent_name[${idx}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.sourceWork.find((el) => {return el.id == 2} ) && this.selected_collaborators.length > 0) {
        this.selected_collaborators.forEach((item, index) => {
          this.body.append(`collaborator_name[${index}]`, item);
        });
        this.requestsCount++;
      }

      if (this.platform_note) {
        this.body.append("platform_note", this.platform_note);
        this.requestsCount++;
      }

      if (this.AgentBeforeSendingToAdministration.length > 0) {
        this.AgentBeforeSendingToAdministration.forEach((item, index) => {
          this.body.append(`AgentBeforeSendingToAdministration[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.fundingManagers.length > 0) {
        this.fundingManagers.forEach((item, index) => {
          this.body.append(`FundingManager[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      

      if (this.selectedRequestStatus.length > 0) {
        this.selectedRequestStatus.forEach((item, index) => {
          this.body.append(`request_status[${index}]`, item["status_id"]);
        });
        this.requestsCount++;
      }

      if (this.sourceWork.length > 0) {
        this.sourceWork.forEach((item, index) => {
          // this.body.append(`work_source[${index}]`, item["id"]);
          this.body.append(`request_source[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.selectAgentType.length > 0) {
        this.selectAgentType.forEach((item, index) => {
          this.body.append(`agent_classification[${index}]`, item["id"]);
        });
        this.typesCount++;
      }
      if (this.selectAgentRefused.length > 0) {
        this.selectAgentRefused.forEach((item, index) => {
          this.body.append(`rejected_ids[${index}]`, item["id"]);
        });
        this.typesCount++;
      }

      if (this.selectedSalesManger.length > 0) {
        this.selectedSalesManger.forEach((item, index) => {
          this.body.append(`sales_manager_classification[${index}]`, item["id"]);
        });
        this.typesCount++;
      }

      if (this.selectedSalaryList.length > 0) {
        this.selectedSalaryList.forEach((item, index) => {
          this.body.append(`salary_source[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.selectedFundingManger.length > 0) {
        this.selectedFundingManger.forEach((item, index) => {
          this.body.append(`funding_manager_classification[${index}]`, item["id"]);
        });
        this.typesCount++;
      }

      if (this.selectMortgageManger.length > 0) {
        this.selectMortgageManger.forEach((item, index) => {
          this.body.append(`mortgage_manager_classification[${index}]`, item["id"]);
        });
        this.typesCount++;
      }

      if (this.selectGeneralManger.length > 0) {
        this.selectGeneralManger.forEach((item, index) => {
          this.body.append(`general_manager_classification[${index}]`, item["id"]);
        });
        this.typesCount++;
      }

      if (this.selectCustomerServiceClassification.length > 0) {
        this.selectCustomerServiceClassification.forEach((item, index) => {
          this.body.append(`customer_service_classification[${index}]`, item["id"]);
        });
        this.typesCount++;
      }

      if (this.customerServiceNote) {
        this.body.append("customer_service_note_search", this.customerServiceNote);
      }

      //================================================================ 

      if (this.isCustomerServiceReview === "نعم") {
        this.body.append("RequestCustomerServiceCheck", 1);
      }

      if (this.isCustomerServiceReview === "لا") {
        this.body.append("RequestCustomerServiceCheck", 0);
      }
      //================================================================ 


      if (this.csDateFrom) {
        this.body.append("cs_date_from", this.csDateFrom);
      }

      if (this.csDateTo) {
        this.body.append("cs_date_to", this.csDateTo);
      }

      if (this.selectedProductType.length > 0) {
        this.selectedProductType.forEach((item, index) => {
          this.body.append(`request_product_type[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.selectedRegionList.length > 0) {
        this.selectedRegionList.forEach((item, index) => {
          this.body.append(`customer_region_ip[${index}]`, item["text"]);
        });
        this.clientCount++;
      }

      if (this.selectedTypeRequest.length > 0) {
        this.selectedTypeRequest.forEach((item, index) => {
          this.body.append(`request_types[${index}]`, item["value"]);
        });
        this.requestsCount++;
      }

      if (this.selectedWorkList.length > 0) {
        this.selectedWorkList.forEach((item, index) => {
          this.body.append(`work_source[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.selectedCustomerNeeds.length > 0) {
        this.selectedCustomerNeeds.forEach((item, index) => {
          this.body.append(`MortgageCustomerNeeds[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      
      if (this.selectedRejection_lists.length > 0) {
        this.selectedRejection_lists.forEach((item, index) => {
          this.body.append(`AgentRejectionReason[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }


      if (this.selectedRequest_descriptions.length > 0) {
        this.selectedRequest_descriptions.forEach((item, index) => {
          this.body.append(`RequestDescription[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.selectedCustomerObjections.length > 0) {
        this.selectedCustomerObjections.forEach((item, index) => {
          this.body.append(`MortgageCustomerObjections[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.selectedCustomerObsatacles.length > 0) {
        this.selectedCustomerObsatacles.forEach((item, index) => {
          this.body.append(`MortgageCustomerObsatacles[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }


      if (this.selectedFundingSide.length > 0) {
        this.selectedFundingSide.forEach((item, index) => {
          this.body.append(`funding_source[${index}]`, item["id"]);
        });
        this.requestsCount++;
      }

      if (this.selectedQualityUsers.length > 0) {
        this.selectedQualityUsers.forEach((item, index) => {
          this.body.append(`quality_of_request[${index}]`, item["id"]);
        });
        this.qualityCount++;
      }

      if (this.selectedVarityQuality.length > 0) {
        this.selectedVarityQuality.forEach((item, index) => {
          this.body.append(`quality_classification_of_request[${index}]`, item["id"]);
        });
        this.qualityCount++;
      }

      if (this.selectedQualityStatus.length > 0) {
        this.selectedQualityStatus.forEach((item, index) => {
          this.body.append(`quality_status_of_request[${index}]`, item["id"]);
        });
        this.qualityCount++;
      }

      if (this.allType === "سلبي") {
        this.body.append("agent_positive_or_negative_classification", 0);
        this.typesCount++;
      }

      if (this.allType === "ايجابي") {
        this.body.append("agent_positive_or_negative_classification", 1);
        this.typesCount++;
      }

      if (this.allType === "بدون") {
        this.body.append("agent_positive_or_negative_classification", 2);
        this.typesCount++;
      }

      if (this.selectedStatusFilter === "استشاري قائم") {
        this.body.append("agent_active_or_archived_classification", 1);
        this.requestsCount++;
      }

      if (this.selectedStatusFilter === "استشاري مؤرشف") {
        this.body.append("agent_active_or_archived_classification", 0);
        this.requestsCount++;
      }

      
      if (this.selectedAcceptArchivedOrNot === "نعم") {
        this.body.append("ApproveForQualityArchivedOrNot", 1);
        this.requestsCount++;
      }

      if (this.selectedAcceptArchivedOrNot === "لا") {
        this.body.append("ApproveForQualityArchivedOrNot", 0);
        this.requestsCount++;
      }

      if (this.phoneNumber) {
        this.body.append("customer_phone", this.phoneNumber);
        this.clientCount++;
      }

      if (this.salaryFrom) {
        this.body.append("customer_salary_from", this.salaryFrom);
        this.clientCount++;
      }

      if (this.salaryTo) {
        this.body.append("customer_salary_to", this.salaryTo);
        this.clientCount++;
      }

      if (this.birthDate) {
        this.body.append("customer_birth_date", this.birthDate);
        this.clientCount++;
      } else {
        this.body.delete("customer_birth_date");
      }

      if (this.counter === 1) {
        this.$store.state.allRequests = [];
        this.body.append("page", 1);
      }

      if (this.getRequestsType === "فارغه") {
        this.body.append("note_status", 0);
        this.requestsCount++;
      }

      if (this.getRequestsType === "بها محتوي") {
        this.body.append("note_status", 1);
        this.requestsCount++;
      }

      if (this.isAplicationInstal === "نعم") {
        this.body.append("customer_app_download", 1);
        this.clientCount++;
      }

      if (this.isAplicationInstal === "لا") {
        this.body.append("customer_app_download", 0);
        this.clientCount++;
      }

      if (this.selectedNationality === "سعودي") {
        this.body.append("CustomerNationality", 1);
        this.clientCount++;
      }

      if (this.selectedNationality === "غير سعودي") {
        this.body.append("CustomerNationality", 5);
        this.clientCount++;
      }
      
      if (this.PossibleToSellToCustomer === "نعم") {
        this.body.append("RequestPossibleToSellToCustomer", 1);
        this.clientCount++;
      }

      if (this.PossibleToSellToCustomer === "لا") {
        this.body.append("RequestPossibleToSellToCustomer", 0);
        this.clientCount++;
      }

      if (this.PossibleToSellToCustomer === "لا يوجد") {
        this.body.append("RequestPossibleToSellToCustomer", 2);
        this.clientCount++;
      }

      if (this.selectedYouHave === "شركة") {
        this.body.append("CustomerYouHave", "company");
        this.clientCount++;
      }

      if (this.selectedYouHave === "مؤسسة") {
        this.body.append("CustomerYouHave", "institution");
        this.clientCount++;
      }

      if (this.selectedYouHave === "فرد") {
        this.body.append("CustomerYouHave", "individual");
        this.clientCount++;
      }

      if (this.selectedSourceOfIncome === "نقاط بيع") {
        this.body.append("CustomerSourceOfIncome", "selling_points");
        this.clientCount++;
      }
      if (this.selectedSourceOfIncome === "أمتلك منشأة تجارية") {
        this.body.append("CustomerSourceOfIncome", "own_commercial_establishment");
        this.clientCount++;
      }
      if (this.selectedSourceOfIncome === "أمتلك عقار") {
        this.body.append("CustomerSourceOfIncome", "own_property");
        this.clientCount++;
      }
      if (this.selectedSourceOfIncome === "راتب فقط") {
        this.body.append("CustomerSourceOfIncome", "salary_only");
        this.clientCount++;
      }
      if (this.selectedSourceOfIncome === "قوائم مالية") {
        this.body.append("CustomerSourceOfIncome", "financial_menu");
        this.clientCount++;
      }

      if (this.selectedSourceOfIncome === "لا يوجد") {
        this.body.append("CustomerSourceOfIncome", "nothing");
        this.clientCount++;
      }

      if (this.selectedHamlaSource && this.selectedHamlaSource.trim()) {
        this.body.append("customer_hamla_source", this.selectedHamlaSource.trim());
        this.clientCount++;
      }

      if (this.selectedReferral) {
        this.body.append("referral_id", this.selectedReferral);
        this.requestsCount++;
      }

      if (this.selectedHaveSalary === "نعم") {
        this.body.append("CustomerHaveSalary", "yes");
        this.clientCount++;
      }

      if (this.selectedHaveSalary === "لا") {
        this.body.append("CustomerHaveSalary", "no");
        this.clientCount++;
      }

      if (this.requestDateFrom) {
        this.body.append("request_date_from", this.requestDateFrom);
        this.requestsCount++;
      }

      if(this.situation_improve_date_from) {
        this.body.append("RequestMortgageSituationImproveDateFrom", this.situation_improve_date_from);
        this.requestsCount++;
      }else{
        this.body.delete("RequestMortgageSituationImproveDateFrom");
      }

      if(this.situation_improve_date_to) {
        this.body.append("RequestMortgageSituationImproveDateTo", this.situation_improve_date_to);
        this.requestsCount++;
      }else{
        this.body.delete("RequestMortgageSituationImproveDateTo");
      }


      if (this.ExitDateFromReport) {
        this.body.append("ExitDateFromReport", this.ExitDateFromReport);
        this.requestsCount++;
      }else{
        this.body.delete("ExitDateFromReport");
      }

      if (this.ExitDateToReport) {
        this.body.append("ExitDateToReport", this.ExitDateToReport);
        this.requestsCount++;
      }else{
        this.body.delete("ExitDateToReport");
      }

      if (this.RecievedDateFromReport) {
        this.body.append("RecievedDateFromReport", this.RecievedDateFromReport);
        this.requestsCount++;
      }else{
        this.body.delete("RecievedDateFromReport");
      }

      if (this.RecievedDateToReport) {
        this.body.append("RecievedDateToReport", this.RecievedDateToReport);
        this.requestsCount++;
      }else{
        this.body.delete("RecievedDateToReport");
      }
      

      if (this.requestDateTo) {
        this.body.append("request_date_to", this.requestDateTo);
        this.requestsCount++;
      } else {
        this.body.delete("request_date_to");
      }

      if (this.completeDateFrom) {
        this.body.append("complete_date[0]", this.completeDateFrom);
        this.requestsCount++;
      } else {
        this.body.delete("complete_date[0]");
      }

      if (this.completeDateTo) {
        this.body.append("complete_date[1]", this.completeDateTo);
        this.requestsCount++;
      } else {
        this.body.delete("complete_date[1]");
      }

      //==============================================================
      if (this.adminDateFrom) {
        this.body.append("admin_date[0]", this.adminDateFrom);
        this.requestsCount++;
      } else {
        this.body.delete("admin_date[0]");
      }

      if (this.adminDateTo) {
        this.body.append("admin_date[1]", this.adminDateTo);
        this.requestsCount++;
      } else {
        this.body.delete("admin_date[1]");
      }
      //==============================================================
      if (this.agentDateFrom) {
        this.body.append("agent_date[0]", this.agentDateFrom);
        this.requestsCount++;
      } else {
        this.body.delete("agent_date[0]");
      }

      if (this.agentDateTo) {
        this.body.append("agent_date[1]", this.agentDateTo);
        this.requestsCount++;
      } else {
        this.body.delete("agent_date[1]");
      }
      //==============================================================

      if (this.updatedDateFrom) {
        this.body.append("request_date_updated_from", this.updatedDateFrom);
        this.requestsCount++;
      } else {
        this.body.delete("request_date_updated_from");
      }

      if (this.updatedDateTo) {
        this.body.append("request_date_updated_to", this.updatedDateTo);
        this.requestsCount++;
      } else {
        this.body.delete("request_date_updated_to");
      }

      if (this.UnUpdatedDate) {
        this.body.append("request_date_did_not_updated_from", this.UnUpdatedDate);
        this.requestsCount++;
      } else {
        this.body.delete("request_date_did_not_updated_from");
      }

      if (this.resiveFromQuality === "نعم") {
        this.body.append("quality_request_received", 1);
        this.qualityCount++;
      }

      if (this.resiveFromQuality === "لا") {
        this.body.append("quality_request_received", 0);
        this.qualityCount++;
      }

      if (this.qualityArchive === "لا") {
        this.body.append("request_archived_by_quality", 0);
        this.qualityCount++;
      }

      if (this.isHasProperty === "نعم") {
        this.body.append("real_estate_has_property", 1);
      }

      if (this.isHasProperty === "لا") {
        this.body.append("real_estate_has_property", 0);
      }


      if (this.isHasCalls === "نعم") {
        this.body.append("request_has_calls", 1);

        if (this.callConsultants.length > 0) {
          this.callConsultants.forEach((item, index) => {
            const callAgentName = item?.name_in_callCenter?.trim();
            if (callAgentName) {
              this.body.append(`request_calls_user_id[${index}]`, callAgentName);
            }
          });
          this.requestsCount++;
        }

        if (this.callsDurationFrom) {
          this.body.append("request_calls_duration_from", this.callsDurationFrom);
          this.requestsCount++;
        }

        if (this.callsDurationTo) {
          this.body.append("request_calls_duration_to", this.callsDurationTo);
          this.requestsCount++;
        }

        if (this.callsDateFrom) {
          this.body.append("request_calls_date_from", this.callsDateFrom);
          this.requestsCount++;
        }

        if (this.callsDateTo) {
          this.body.append("request_calls_date_to", this.callsDateTo);
          this.requestsCount++;
        }
      }

      if (this.isHasCalls === "لا") {
        this.body.append("request_has_calls", 0);
      }

      if (this.qualityArchive === "نعم") {
        this.body.append("request_archived_by_quality", 1);
        this.qualityCount++;
      }

      if (this.filterTypeParts) {
        this.body.append("text_name", this.filterTypeParts);
        this.requestsCount++;
      }
      if (this.$store.state.CustomerNameOrComment !== undefined && this.$store.state.CustomerNameOrComment != '') {
        this.body.append("CustomerNameOrComment", this.$store.state.CustomerNameOrComment);
      }

      if (this.$store.state.InFundingReportOrNot !== undefined && this.$store.state.InFundingReportOrNot != null  && this.$store.state.InFundingReportOrNot != 2) {
        this.body.append("InFundingReportOrNot", this.$store.state.InFundingReportOrNot);
      }
      let url = `/v2/employee/Requests/search?type=${this.pageName}&per_page=${this.$store.state.counterOfShow}`;
      axiosInstance
        .post(url, this.body)
        .then((res) => {
          
          if(this.pageName == 'funding_duration_average'){
            this.$emit('refresh_funding_duration_average',res.data.payload.sum_of_funding_duration)
          }
          this.$store.state.admin_search_active = true;
          let response = res.data.payload.data;
          this.$store.state.allRequests.push(...response);

          this.$store.state.allData.push(...response);
          this.$store.state.allSearch.push(...response);

          this.$store.state.recievedData.push(...response);
          this.$store.state.recievedSearch.push(...response);

          this.$store.state.followData.push(...response);
          this.$store.state.followSearch.push(...response);

          this.$store.state.featureData.push(...response);
          this.$store.state.featureSearch.push(...response);

          this.$store.state.archiveData.push(...response);
          this.$store.state.archiveSearch.push(...response);

          this.$store.state.latestData.push(...response);
          this.$store.state.latestSearch.push(...response);

          this.$store.state.loadingData = false;
          res.data.payload.data.map((item) => {
            this.setTblData(item);
            item["starChecked"] = false;
            return item;
          });

          this.$store.state.loadingData = false;
          this.$store.state.allLoading = false;
          this.$store.state.recievedLoading = false;
          this.$store.state.followLoading = false;
          this.$store.state.featureLoading = false;
          this.$store.state.archiveLoading = false;
          this.$store.state.latestLoading = false;
          this.$store.state.pagination.count = res.data.payload.searched;
        })
        .catch((err) => {
          this.$store.state.loadingData = false;
          this.$store.state.allLoading = false;
          this.$store.state.recievedLoading = false;
          this.$store.state.followLoading = false;
          this.$store.state.featureLoading = false;
          this.$store.state.archiveLoading = false;
          this.$store.state.latestLoading = false;
        });
      this.$store.state.bodySearch = this.body;
    },
    setTblData(res) {
      // Superset row shape: a single mapping that produces every column key
      // any of the admin requests pages renders (AllRequests, Processing,
      // Recieved, Followed, HasPersonal, Featured, Archieved, Funding-
      // Duration, Administration, LateRequests, ArchivedInQuality, ...).
      // Pages with their own narrower `setTblData` keep producing the same
      // shape on initial load; after a "بحث" submit the dialog re-uses this
      // same row so columns (incl. agent_class_note / cs_class_note via
      // ClassificationCell, agent_date, source_text, quacomment_date, ...)
      // are populated identically.
      const customer = res.customer || {};
      const createdAtFormatted = res.created_at ? formatDate(res.created_at) : "";
      const agentDateFormatted = res.agent_date ? formatDate(res.agent_date) : "-";
      const adminDateFormatted = res.admin_date ? formatDate(res.admin_date) : "-";
      const csDateFormatted = res.cs_date ? formatDate(res.cs_date) : "-";
      const updatedAtFormatted = res.updated_at ? formatDate(res.updated_at) : "";
      const qualityReceived =
        res.is_recieved_from_quality ||
        res.highlight_received ||
        res.class_id_quality != null ||
        res.quacomment != null;

      const newItem = {
        // identifiers
        id: res.id,
        isSelected: false,
        "رقم الطلب": res.id,

        // dates (both English & Arabic keys so any header maps)
        created_at: createdAtFormatted,
        "تاريخ الطلب": res.req_date || createdAtFormatted,
        agent_date: agentDateFormatted,
        "تاريخ الاستشاري": agentDateFormatted,
        admin_date: adminDateFormatted,
        "تاريخ الادمن": adminDateFormatted,
        cs_date: csDateFormatted,
        "تاريخ خدمه العملاء": csDateFormatted,
        "التاريخ عند الاستشاري": agentDateFormatted,
        updated_at: updatedAtFormatted,
        "تم التحديث في": updatedAtFormatted,
        situation_improve_date: res.situation_improve_date
          ? formatDate(res.situation_improve_date)
          : "",

        // type / product
        type: res.type || "لا يوجد نوع طلب",
        "نوع الطلب": res.type || "لا يوجد نوع طلب",
        req_product_type:
          this.selected_products_list.find(
            (item) => item.id === res.req_product_type
          )?.value || "لا_يوجد",

        // funding-duration report (kept as-is for that page)
        "تاريخ الدخول": res.recived_date_report,
        "تاريخ الخروج": res.exit_date_from_funding_report,
        "المدة بالايام": res.funding_duration_average,
        "مدير التمويل": res.fundingManager?.name,

        // customer
        customer_name: customer.name,
        customer_mobile: customer.mobile,
        عميل: customer.name,
        الجوال: customer.mobile,

        // status (3 spellings used across pages)
        status: res.status,
        "حاله الطلب": res.status,
        "حالة الطلب": res.status,

        // source
        source: res.source_text,
        "مصدر المعامله": SourceValue(res.source),
        source_text: res.source_text ?? null,

        ...buildRequestAgentCsTableFields(res),
        agent_user_id: res.user_id ?? res.user?.id ?? null,
        class_id_agent: res.class_id_agent ?? null,
        class_id_agent_text: res.class_id_agent_text ?? null,
        class_id_agent_color: res.class_id_agent_color ?? null,
        class_id_agent_is_deleted: res.class_id_agent_is_deleted ?? false,
        agent_name: res.agent_name ?? res.user?.name ?? null,
        agent_notes:
          res.agent_notes ?? res.agent_note ?? res.comment ?? null,
        comment_date: res.comment_date ?? null,
        has_agent_calls: [true, 1, "1", "true"].includes(res?.has_agent_calls),
        has_cs_calls: [true, 1, "1", "true"].includes(res?.has_cs_calls),
        "تصنيف الاستشاري": res.class_id_agent_text,

        // customer service (powers ClassificationCell -> cs_class_note)
        class_id_cs: res.class_id_cs ?? null,
        class_id_cs_text: res.class_id_cs_text ?? null,
        class_id_cs_color: res.class_id_cs_color ?? null,
        class_id_cs_is_deleted: res.class_id_cs_is_deleted ?? false,
        cs_note: res.cs_note ?? res.customer_service_note ?? null,
        customer_service_note:
          res.customer_service_note ?? res.cs_note ?? null,
        customer_service_note_date: res.customer_service_note_date
          ? formatDate(res.customer_service_note_date)
          : null,

        // quality
        quality_notes: res.quality_notes,
        quacomment_date: res.quacomment_date,
        "هل تم استلامه من قبل الجوده": qualityReceived ? "نعم" : "لا",

        // admin processing / misc
        "تمت المعالجة": res.is_administration_processed == 1 ? "نعم" : "لا",
        request_description:
          res.requestDescription?.option ||
          res.request_description_other ||
          "لا يوجد",
        العمليات: res.sent_basket?.count,
      };

      const exists = this.$store.state.tableData.some(
        (item) => item.id === newItem.id
      );

      if (!exists) {
        this.$store.state.tableData.push(newItem);
      }
    },

    getTypeRequestList() {
      let data = [
        {
          color: "red",
          value: "شراء",
        },
        {
          color: "red",
          value: "رهن",
        },
        {
          color: "red",
          value: "تساهيل",
        },
        {
          color: "red",
          value: "شراء-دفعة",
        },
        {
          color: "red",
          value: "رهن-شراء",
        },
      ];
      this.typeRequest = data.map((item) => {
        item["color"] = "red";
        item["text"] = item["value"];
        return item;
      });
    },

    getRequestClassification(val) {
      const url = buildClassificationFilterUrl(val, this.includeDeletedClassifications);
      axiosInstance.get(url).then((res) => {
        if (val === 1) {
          this.selesMangerType = res.data.payload;
          this.requestClass(this.selesMangerType);
        } else if (val === 2) {
          this.fundingMangerType = res.data.payload;
          this.requestClass(this.fundingMangerType);
        } else if (val === 3) {
          this.marteryMangerType = res.data.payload;
          this.requestClass(this.marteryMangerType);
        } else if (val === 4) {
          this.genaralMangerType = res.data.payload;
          this.requestClass(this.genaralMangerType);
        } else if (val === 5) {
          this.qualityUserType = res.data.payload;
          this.requestClass(this.qualityUserType);
        } else if (val === 0) {
          this.selesAgentType = res.data.payload;
          this.requestClass(this.selesAgentType);
        } else if (val === "cs") {
          this.csAgentType = res.data.payload;
          this.requestClass(this.csAgentType);
        }
      });
    },

    getSelectedValueManger(val) {
      this.selectedMang = val;
      if (val.length && this.selectedStatusFilter === "استشاري مؤرشف") {
        this.getAllAgents("agent", 0, val);
      } else if (val.length && this.selectedStatusFilter === "استشاري قائم") {
        this.getAllAgents("agent", 1, val);
      } else if (val.length && this.selectedStatusFilter === "الكل") {
        this.getAllAgents("agent", 1, val);
      }
    },

    getTypeRequest(val) {
      this.selectedTypeRequest = val;
    },

    getSelectedValueAgent(val) {
      this.selectAgent = val;
    },

    

    getAgentBeforeSendingToAdministration(val) {
      this.AgentBeforeSendingToAdministration = val;
    },

    getFundingManagers(val) {
      this.fundingManagers = val;
    },

    getSelectedAgentType(val) {
      this.selectAgentType = val;
    },
    getSelectAgentRefused(val) {
      this.selectAgentRefused = val;
    },

    getRequestStatus(val) {
      this.selectedRequestStatus = val;
    },

    getSelectedMangerType(val) {
      this.selectedSalesManger = val;
    },

    getSelectedFundingType(val) {
      this.selectedFundingManger = val;
    },

    getMerteryType(val) {
      this.selectMortgageManger = val;
    },

    getGeneralManger(val) {
      this.selectGeneralManger = val;
    },

    getSelectedCustomerServiceClassification(val) {
      this.selectCustomerServiceClassification = val;
    },

    getSelectedProductType(val) {
      this.selectedProductType = val;
    },

    getAllManger(role, status) {
      this.allMangers = [];
      let body = { role: role };
      if (status === 0) {
        body = {
          status: status,
          role: role,
        };
      }

      let url = "/employee/admin/filterUsers";
      axiosInstance.post(url, body).then((res) => {
        this.allMangers = res.data.payload;
        this.allMangers.map((item) => {
          item["color"] = "red";
          item["text"] = item["name"];
          return item;
        });
      });
    },

    getAllFundingManagers(role, status) {
      this.allFundingManagers = [];
      let body = { role: role };
      if (status === 0) {
        body = {
          status: status,
          role: role,
        };
      }

      let url = "/employee/admin/filterUsers";
      axiosInstance.post(url, body).then((res) => {
        this.allFundingManagers = res.data.payload;
        this.allFundingManagers.map((item) => {
          item["color"] = "red";
          item["text"] = item["name"];
          return item;
        });
      });
    },

    getQualityStatus() {
      let url = "/employee/quality/quality-request/request/status";
      axiosInstance.get(url).then((res) => {
        this.qualityStatus = res.data.payload.map((item) => {
          item["color"] = "red";
          item["text"] = item["status_value"];
          return item;
        });
      });
    },

    getAllAgents(role, status, val) {
      this.allAgents = [];
      let body = new FormData();
      body.append("role", role);
      if (status === 0 && !val) {
        body.append("status", status);
        body.append("role", role);
      } else if (status === 1 && !val) {
        body.append("status", status);
        body.append("role", role);
      }
      if (val) {
        val.forEach((item, index) => {
          this.selectedManger.push(`'manager_id[${index}]': '${item["id"]}'`);
        });
      }

      let removeDublicate = removeDuplicated(this.selectedManger);

      if (removeDublicate.length) {
        val.forEach((item, index) => {
          body.append(`manager_id[${index}]`, item["id"]);
        });
        body.append("status", status);
        body.append("role", role);
      }

      let url = "/employee/admin/filterUsers";
      axiosInstance.post(url, body).then((res) => {
        this.allAgents = res.data.payload;
        this.allAgents.map((item) => {
          item["color"] = "red";
          item["text"] = item["name"];
          return item;
        });


        this.callCenterConsultants = (res.data.payload || []).map((a) => ({
          id: a.id,
          name_in_callCenter: a.name_in_callCenter,
          text: a.name || a.name_in_callCenter, 
        }));

      });
    },

    get_customer() {
      if (document.cookie !== "") {
        axiosInstance.get("/agent/RelatedCustomers").then((response) => {
          if (this.$store.state.agent_customers) {
            this.$store.state.agent_customers = response.data.payload;
          }
        });
      }
    },

    getSupAdmin() {
      let url = "/v2/employee/quality-users";
      if (!this.includeAll) {
        url += "?status=1";
      }
      axiosInstance.get(url).then((res) => {
        this.quality = res.data.payload.map((item) => {
          item["color"] = "red";
          // item["text"] = item["name_for_admin"];
          item["text"] = item["name_for_admin"] || item["name"];
          return item;
        });
      });
    },

    get_funding_sources() {
      axiosInstance.get("/agent/Funding/Sources").then((response) => {
        this.fundingSide = response.data.payload.map((item) => {
          item["color"] = "red";
          item["text"] = item["value"];
          return item;
        });
      });
    },

    get_collaborators() {
      this.getting = true;
      axiosInstance
        .get("/agent/Collaborators")
        .then((response) => {
          this.collaborators = response.data.payload;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.getting = false;
        });
    },

    getProductsType() {
      let url = "/customer/SelectedProduct";
      axiosInstance.get(url).then((res) => {
        this.selected_products_list = res.data.payload;
      });
    },
    getProductType() {
      let url = "/customer/SelectedProduct";
      axiosInstance.get(url).then((res) => {
        this.productType = [
          {
            color: "red",
            id: "",
            productId: 0,
            text: "بدون",
            type: "",
            value: "بدون",
          },
          ...res.data.payload.map((item) => {
            item["color"] = "red";
            item["text"] = item["value"];
            return item;
          }),
        ];
        console.log("productType", this.productType);
      });
    },
  },

  mounted() {
    this.getAllFundingManagers("fundingManager");
    this.getAllManger("manager");
    this.getAllAgents("agent");
    this.getRequestClassification(0);
    this.getRequestClassification("cs");
    this.getRequestClassification(1);
    this.getRequestClassification(2);
    this.getRequestClassification(3);
    this.getRequestClassification(4);
    this.getRequestClassification(5);
    this.reloadAllClassificationsForFilter().finally(() => {
      this.enableClassificationFilterWatchAfterInitialLoad();
    });
    this.getProductType();
    this.getProductsType();
    this.requestStatus();
    this.getRequestSource();
    this.getRequestType();
    this.getSelectedRegion();
    this.getHamlaSource();
    this.getReferrals();
    this.getTypeRequestList();
    this.get_work_list();
    this.MortgageCustomerNeeds();
    this.get_rejection_list();
    this.get_request_description();
    this.MortgageCustomerObjections();
    this.MortgageCustomerObsatacles();
    this.get_salary_sources();
    this.get_funding_sources();
    this.get_collaborators();
    this.getSupAdmin();
    this.getQualityStatus();
    

    this.selesAgentRefuseList = this.$store.state.rejection_list.map(item => ({
                id: item.id,
                text: item.title, // Renaming title to value
                value: item.title, // Renaming title to value
                color: "orange" // Renaming title to value
              }));
  },
};
</script>

<style>
/* Campaign / campaign-source menus. The menu is rendered at the end of <body>,
   outside the dialog, so it inherits neither the page direction nor the dark
   palette — both are set here off the class the component picks from its own
   dark flag (referralMenuClass). */
.referral-menu .v-list,
.referral-menu .v-list-item {
  direction: rtl;
  text-align: right;
}

/* The list scrolls (maxHeight) while the search box stays pinned to the top of
   it, so a long campaign list stays searchable instead of scrolling its own
   search field out of view. */
.referral-menu .referral-search,
.referral-menu .hamla-source-search {
  position: sticky;
  top: 0;
  z-index: 2;
  padding-top: 8px;
  padding-bottom: 4px;
}

.referral-menu--light .referral-search,
.referral-menu--light .hamla-source-search {
  background: #ffffff;
}

.referral-menu--dark .referral-search,
.referral-menu--dark .hamla-source-search {
  background: #23272e;
}

/* The search box lives inside the menu, outside .filterAllRequestsTabs--dark,
   so it needs the same dark-mode text treatment applied on its own. */
.referral-menu--dark .referral-search .v-input input,
.referral-menu--dark .referral-search .v-label,
.referral-menu--dark .referral-search .v-icon,
.referral-menu--dark .hamla-source-search .v-input input,
.referral-menu--dark .hamla-source-search .v-label,
.referral-menu--dark .hamla-source-search .v-icon {
  color: #f3f5f7 !important;
}

.referral-menu .referral-option {
  min-height: 48px;
}

.referral-option-name {
  font-weight: 600;
}

/* The link is secondary information, so it rides under the name in a smaller,
   dimmer line. It keeps LTR character order — a URL laid out RTL reads with its
   punctuation in the wrong places — but stays right-aligned with the name. */
.referral-option-url {
  font-size: 11px;
  direction: ltr;
  text-align: right;
}

.referral-menu--dark .referral-option-name {
  color: #f3f5f7 !important;
}

.referral-menu--dark .referral-option-url {
  color: rgba(243, 245, 247, 0.72) !important;
}

.referral-menu--light .referral-option-name {
  color: rgba(0, 0, 0, 0.87) !important;
}

.referral-menu--light .referral-option-url {
  color: rgba(0, 0, 0, 0.6) !important;
}

.adminFilter--light {
  background: #ffffff;
  color: #000000;
}

.adminFilter--dark {
  background: #121212;
  color: #ffffff;
}

.adminFilter--dark hr {
  border-color: rgba(255, 255, 255, 0.12);
}

.filterAllRequestsTabs {
  border-radius: 8px;
}

.filterAllRequestsTabs--light {
  background: #ffffff;
}

.filterAllRequestsTabs--dark {
  background: #121212;
  color: #ffffff;
}

.filterAllRequestsTabs--dark .DailyReportAdmin {
  background: #121212;
}

/* Make outlined inputs match dark mode instead of looking like a big white block */
.filterAllRequestsTabs--dark .v-text-field--outlined > .v-input__control > .v-input__slot,
.filterAllRequestsTabs--dark .v-autocomplete.v-text-field--outlined > .v-input__control > .v-input__slot,
.filterAllRequestsTabs--dark .v-select.v-text-field--outlined > .v-input__control > .v-input__slot {
  background: #1f1f1f !important;
}

.filterAllRequestsTabs--dark .v-label,
.filterAllRequestsTabs--dark .v-input input,
.filterAllRequestsTabs--dark .v-select__selection,
.filterAllRequestsTabs--dark .v-select__selections {
  color: #ffffff !important;
}

.filterAllRequestsTabs--dark .v-icon {
  color: #ffffff !important;
}

#adminFilter
  .selectInput
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 2px solid #f7f8fb !important;
  margin-top: 0 !important;
}

.v-chip--select {
  background-color: #3c5de7 !important;
  color: white !important;
  border-radius: 1% !important;
}

.v-chip__close::before {
  color: white !important;
}

.v-col {
  margin: 0px !important;
}

::-webkit-calendar-picker-indicator {
  left: -22px;
  position: absolute;
  z-index: 1;
  opacity: 0;
}

input[type="date"] {
  text-align: end;
}

.panalContextFilter .col-md-4,
.panalContextFilter .col-md-6,
.panalContextFilter .col-lg-12,
.panalContextFilter .col-md-12 {
  padding-bottom: 0px;
  padding-top: 0px;
}

.theme--light.v-expansion-panels
  .v-expansion-panel-header
  .v-expansion-panel-header__icon
  .v-icon {
  color: black !important;
  background: #f7f7f7;
}
</style>